<div class="history-header-container justify-content">
  <span class="section-title">{{ headerText }}</span>
  <div>
    @if (!hideFilters) {
      <button mat-icon-button (click)="toggleFilterDrawer()">
        <img src="assets/img/filters.svg" style="height: 22px; width: 22px" alt="">
      </button>
    }
    <button mat-icon-button
            (click)="refreshComponent()"
            [disabled]="refreshing"
            [ngClass]="refreshing ? 'refreshing' : ''">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>
